import { useState } from 'react';
import { LoginService, LoginCredentials, LoginResult } from '../services/loginService';
import { KeycloakService } from '../services/keycloakService';
import { useKeycloak } from '../providers/KeycloakProvider';

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { updateAuthenticationState } = useKeycloak();

  const login = async (credentials: LoginCredentials): Promise<boolean> => {
    setLoading(true);
    setError(null);

    try {
      const result: LoginResult = await LoginService.authenticateUser(credentials);
      
      if (result.success && result.tokens) {
        // Ustawianie tokenów w Keycloak instance
        await KeycloakService.setTokensFromLogin(result.tokens);
        
        // Aktualizacja stanu aplikacji
        updateAuthenticationState(true);
        
        return true;
      } else {
        setError(result.error || 'Logowanie nie powiodło się');
        return false;
      }
    } catch (err) {
      setError('Wystąpił nieoczekiwany błąd');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => setError(null);

  return { 
    login, 
    loading, 
    error, 
    clearError 
  };
};